import type { Module } from '@vue-storefront/sdk';
import type { ModuleOptions } from './types';
import { connector } from './connector';

/**
 * @deprecated This type is deprecated and will be removed in the next major version.
 * It is no longer necessary to use this type. Please, check documentation of `magentoModule`.
 */
export interface StatamicModuleType extends Module {
  connector: ReturnType<typeof connector>;
}

/**
*
 * export const sdk = initSDK(sdkConfig);
 *
 * // Breaking changes:
 * // - Custom queries are now a second argument of the methods.
 *
 * const customQuery = {
 *   cart: 'entries-custom-query',
 *   metadata: {
 *     fields: 'id items { uid }'
 *   }
 * };
 * - const cart = await sdk.statamic.entry({ id: '123'}, { customQuery });
 * + const cart = await sdk.statamic.entries({ ... }, customQuery);
 *
 * ```
 *
 * @example
 * Initialization of the Magento module.
 *
 * ```js
 * import { initSDK, buildModule } from '@vue-storefront/sdk';
 * import { statamicModule, StatamicModuleType } from '~/integrations/statamic';
 *
 * const sdkConfig = {
 *   statanuc:
 *     buildModule(
 *       statamicModule,
 *       {
 *         apiUrl: 'http://localhost:8181/statamic',
 *       }
 *     )
 * };
 *
 * export const sdk = initSDK<typeof sdkConfig>(sdkConfig);
 * ```
 */
export const statamicModule = (options: ModuleOptions) => {
  return {
    connector: connector(options),
  } satisfies Module;
};

export { client } from './client';
export type * from './methods';
